import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import GroupListComponent from '../../Components/GroupByComponent/GroupListComponent';

function GroupList() {
    let navigate = useNavigate();
    let params = useParams();

    return (
        <div>
            <GroupListComponent navigate={navigate} id={params.id}></GroupListComponent>
        </div>
    )
}

export default GroupList;